import * as React from 'react'
import * as PropTypes from 'prop-types'
import styled from 'styled-components'

import Layout from '../../../../components/ui/Layout/Layout'

import { LANDING } from '../../../../services/data/registrationSteps.json'

import ReferralImage from '../../../../assets/img/referral-image.webp'

import LinkButton from '../../../../components/ui/LinkButton/LinkButton'

import * as ProfileApiServices from '../../../../services/api/requests/Profile'
import { setGAPageView } from '../../../../services/analytics/google-analytics'

const Title = styled.h1`
  font-size: 1.5rem;
  text-align: center;
  margin-top: 0;
  font-weight: var(--font-weight-bold);
`

const StyledButton = styled(LinkButton)`
  width: 100%;
`

const Description = styled.p`
  text-align: center;
`

const ImgContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const StyledImg = styled.img`
  width: 100%;
  text-align: center;
  display: flex;
  flex-grow: 1;
`

class MainView extends React.Component {
  state = {
    verified: null,
  }

  componentDidMount() {
    const { match = {}, location } = this.props

    const token = match.url ? match.url.split('/')[2] : ''

    if (location) setGAPageView(location.pathname)
    ProfileApiServices.getEmailVerificationWithToken(token)
      .then(response => {
        this.setState({ verified: response.data.status })
      })
      .catch(() => {})
  }

  render() {
    const { verified } = this.state

    return (
      <div>
        <Layout {...this.props}>
          <ImgContainer>
            <StyledImg src={ReferralImage} alt="" />
          </ImgContainer>
          {verified !== null && (
            <Title>
              {verified === 0
                ? 'Invalid Link'
                : verified === 1
                ? 'This link has expired'
                : verified === 2
                ? 'Your email has been verified'
                : 'Unknown Error Occured'}
            </Title>
          )}

          {verified === 0 && (
            <Description>
              To get a new link, go to settings, click More, and hit “Click to
              resend verification link”.
            </Description>
          )}

          {verified === 1 && (
            <Description>
              For your security, we only keep registration links active for 24
              hours. Please go back to settings, click More, and hit “Click to
              resend verification link”.
            </Description>
          )}

          {verified === 2 && (
            <Description>Log in and start exploring Zing.</Description>
          )}

          {verified === 2 && (
            <StyledButton to="/login" variant="primary">
              Go To Login Page
            </StyledButton>
          )}
        </Layout>
      </div>
    )
  }
}

MainView.defaultProps = {
  primaryInfo: null,
  step: LANDING,
  push: null,
}

MainView.propTypes = {
  primaryInfo: PropTypes.shape(),
  step: PropTypes.number,
  push: PropTypes.func,
}

export default MainView
